import * as Yup from "yup";

const TermsAndConditionsValidationSchema = Yup.object().shape({
  agreeTerms: Yup.bool().oneOf([true], "Please confirm your agreement."),
});

export default TermsAndConditionsValidationSchema;
